import React, { useContext, useState } from 'react';
import Img from 'gatsby-image';
import { Breakpoint } from 'react-socks';
import ReactTooltip from 'react-tooltip';
import Carousel from '@interness/web-core/src/components/media/Carousel/Carousel';
import ConditionalWrapper from '@interness/web-core/src/components/structure/ConditionalWrapper/ConditionalWrapper';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import routes from '@interness/web-core/config/routes/index';
import { LanguageContext } from '@interness/web-core/src/providers';
import { useRandomBrandHeaderImages } from '../../../hooks/useRandomBrandHeaderImages';
import { jsx as ___EmotionJSX } from "@emotion/react";
const RandomBrandHeaderImages = props => {
  const {
    0: randomBrands,
    1: setRandomBrands
  } = useState();
  const {
    language
  } = useContext(LanguageContext);
  if (!randomBrands) {
    const random = useRandomBrandHeaderImages(props.count, props.type, props.lowestBrandRating);
    setRandomBrands(random);
    return null;
  } else {
    return ___EmotionJSX(Carousel, null, randomBrands.map(_ref => {
      let {
        brand
      } = _ref;
      const image = brand.header_images.filter(image => image.file.localFile.childImageSharp.fluid.aspectRatio !== 1)[0];
      const brandLink = `${routes[brand.type.type][language]}/${brand.slug}`;
      if (!image) {
        console.log('Header image missing for brand: ', brand.display_name);
      }
      return ___EmotionJSX(ConditionalWrapper, {
        key: image.file.localFile.name,
        condition: props.linkImage,
        wrapper: children => {
          return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Link, {
            to: brandLink,
            "data-tip": brand.display_name
          }, children), ___EmotionJSX(Breakpoint, {
            lage: true,
            up: true
          }, ___EmotionJSX(ReactTooltip, {
            delayShow: 200
          })));
        }
      }, ___EmotionJSX(Img, {
        fluid: image.file.localFile.childImageSharp.fluid,
        alt: brand.display_name,
        loading: "eager"
      }));
    }));
  }
};
RandomBrandHeaderImages.defaultProps = {
  count: 1,
  type: 'all',
  lowestBrandRating: 1,
  linkImage: true
};
export default RandomBrandHeaderImages;